<template>
    <div class="bars-wrapper" v-if="reviews" :class="'x' + (reviews.userScore + '').length">
        <span class="bar-c">
            <span class="txt"><i class="fa fa-star"></i> 5</span>
            <span class="bar-b">
                <span class="bar" :style="'width:' + reviews.stars[5] / reviews.userScore * 100 + '%'" v-if="dataLoaded"></span>
                <span class="bar" style="width:0%" v-else></span>
            </span>
            <span v-if="dataLoaded" class="txt">({{ reviews.stars[5] }})</span>
            <span v-else class="txt">(...)</span>
        </span>
        <span class="bar-c">
            <span class="txt"><i class="fa fa-star"></i> 4</span>
            <span class="bar-b">
                <span class="bar" :style="'width:' + reviews.stars[4] / reviews.userScore * 100 + '%'" v-if="dataLoaded"></span>
                <span class="bar" style="width:0%" v-else></span>
            </span>
            <span v-if="dataLoaded" class="txt">({{ reviews.stars[4] }})</span>
            <span v-else class="txt">(...)</span>
        </span>
        <span class="bar-c">
            <span class="txt"><i class="fa fa-star"></i> 3</span>
            <span class="bar-b">
                <span class="bar" :style="'width:' + reviews.stars[3] / reviews.userScore * 100 + '%'" v-if="dataLoaded"></span>
                <span class="bar" style="width:0%" v-else></span>
            </span>
            <span v-if="dataLoaded" class="txt">({{ reviews.stars[3] }})</span>
            <span v-else class="txt">(...)</span>
        </span>
        <span class="bar-c">
            <span class="txt"><i class="fa fa-star"></i> 2</span>
            <span class="bar-b">
                <span class="bar" :style="'width:' + reviews.stars[2] / reviews.userScore * 100 + '%'" v-if="dataLoaded"></span>
                <span class="bar" style="width:0%" v-else></span>
            </span>
            <span v-if="dataLoaded" class="txt">({{ reviews.stars[2] }})</span>
            <span v-else class="txt">(...)</span>
        </span>
        <span class="bar-c">
            <span class="txt"><i class="fa fa-star"></i> 1</span>
            <span class="bar-b">
                <span class="bar" :style="'width:' + reviews.stars[1] / reviews.userScore * 100 + '%'" v-if="dataLoaded"></span>
                <span class="bar" style="width:0%" v-else></span>
            </span>
            <span v-if="dataLoaded" class="txt">({{ reviews.stars[1] }})</span>
            <span v-else class="txt">(...)</span>
        </span>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                reviews: [],
                dataLoaded: false
            }
        },
        mounted() {
            var self = this,
            reviews = [];

            $.getJSON('/rest/reviewWidget/get/summary').done(function( data ) {
                self.reviews = data;
                self.dataLoaded = true;
            })
        }
    }
</script>
